<template>
  <div>
    <div class="detailInfo">
      <el-form ref="form" :model="esopVo" class="form" label-width="90px">
        <div class="title">ESOP信息</div>
        <el-row style="margin: 15px 10px 0 0">
          <el-col :span="8">
            <el-form-item label="ESOP编号">
              <el-input v-model="esopVo.esopNo" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="物料编号">
              <el-input v-model="esopVo.materialNo" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="物料名称">
              <el-input v-model="esopVo.materialName" disabled/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="文件类型">
              <el-select v-model="esopVo.fileType">
                <el-option label="受控" value="10"/>
                <el-option label="试行" value="20"/>
                <el-option label="样品" value="30"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="规格型号">
              <el-input v-model="esopVo.specification" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="通知部门" prop="departmentName">
              <el-input v-model="esopVo.departmentName" placeholder="请选择" readonly>
                <el-button slot="append" @click="$refs.selectDepartment.open()">选择</el-button>
              </el-input>
              <!-- 部门选择器 -->
              <department-select ref="selectDepartment" @select="selectDepartment"/>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="title">详细信息</div>
        <Table
            style="margin: 10px"
            :data="esopVo.changeDetailVOS"
            border
            stripe
            :columns="columns"/>
        <div class="title">变更记录</div>
        <div style="padding: 10px 10px 0 10px">
          <el-button type="primary" :disabled="!esopVo.detailVos.length" @click="download">下载</el-button>
          <up-load-file
              ref="upload"
              :show-file-list="false"
              :auth-index="authIndex"
              style="display: inline-block; margin-left: 10px"
              @upload-success="uploadSuccess"/>
        </div>
        <Table
            :columns="columnsTwo"
            :data="esopVo.detailVos"
            style="margin: 10px"
            border
            stripe/>
      </el-form>
    </div>
    <same-customer-level-dialog ref="preview" @save-success="getData()"/>
    <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
  </div>
</template>

<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import SameCustomerLevelDialog from "../SalesManage/businessApplication/SameCustomerLevelDialog";
  import UpLoadFile from "@/components/UploadFile";
  import DepartmentSelect from "@/views/information/Department/DepartmentSelect";

  export default {
    name: "OperationApplicationPreview",
    components: {UpLoadFile, SameCustomerLevelDialog, HandleDetail, DepartmentSelect},
    props: {
      params: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        billId: "",
        billType: "",
        sequId: "",
        dialogVisible: false,
        loading: false,
        authIndex: 192,
        esopVo: {
          esopId: "",
          esopNo: "",
          materialNo: "",
          materialName: "",
          fileType: "",
          changeDetailVOS: [],
          detailVos: [],
          departmentId: 0,
          departmentName: "",
        },
        columns: [
          {
            title: "文件",
            key: "imgPath",
            minWidth: 200,
            tooltip: true,
            render: (h, params) => {
              return h(
                  "span",
                  {
                    style: {
                      color: "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.getFileUrl(params.row.imgPath);
                      },
                    },
                  },
                  params.row.imgPath,
              );
            },
          },
          {
            title: "描述",
            key: "note",
            minWidth: 200,
            tooltip: true,
          },
          {
            title: "创建人",
            key: "creatorName",
            width: 100,
            align: "center",
          },
          {
            title: "创建时间",
            key: "createTime",
            width: 160,
            align: "center",
          },
        ],
        columnsTwo: [
          // {
          //   title: "文件类型",
          //   key: "fileTypeName",
          //   width: 100,
          //   align: "center",
          // },
          {
            title: "文件名称",
            key: "fileName",
            tooltip: true,
            minWidth: 200,
          },
          {
            title: "文件路径",
            key: "filePath",
            tooltip: true,
            minWidth: 200,
          },
          {
            title: "版本",
            key: "version",
            align: "center",
            width: 80,
          },
          {
            title: "创建人",
            key: "creatorName",
            width: 100,
            align: "center",
          },
          {
            title: "创建时间",
            key: "createTime",
            width: 180,
            align: "center",
          },
        ],
        tempFileType: "",
      };
    },
    watch: {
      $route: {
        immediate: true,
        handler(val) {
          if (val.query.billId) {
            this.billId = val.query.billId;
            this.billType = val.query.billType;
            this.sequId = val.query.sequId;
            this.getData();
          }
        },
      },
      params: {
        handler() {
          this.doApprove();
        },
      },
    },
    methods: {
      // 获取详细信息
      getData() {
        this.$emit("loading-status", {loading: true});
        this.$http
            .get("basic", `esopChanges/${this.billId}`)
            .then((resp) => {
              if (resp.success) {
                this.esopVo = Object.assign(this.esopVo, resp.data);
                this.tempFileType = this.esopVo.fileType;
              }
              this.$emit("loading-status", {loading: false});
            })
            .catch(() => {
              this.$emit("loading-status", {loading: false});
            });
      },
      selectDepartment(row) {
        this.esopVo.departmentId = row.departmentID;
        this.esopVo.departmentName = row.departmentName;
      },
      // getNodeValue() {
      //   let params = {
      //     billType: this.billType,
      //     billId: this.billId,
      //     sequId: this.sequId,
      //   };
      //   this.$http.get("basic", "applications/approve", params).then((resp) => {
      //     this.$emit("loading-status", { loading: false });
      //     this.note = resp.data.applicationVarVOS[1].varValue;
      //     if (resp.data.applicationVarVOS.length) {
      //       if (resp.data.applicationVarVOS[resp.data.applicationVarVOS.length - 1].varValue == 10) {
      //         this.imgShow = false;
      //       } else {
      //         this.imgShow = true;
      //         this.getImgUrl(resp.data.applicationVarVOS[0].varValue);
      //       }
      //     }
      //   });
      // },

      getFileUrl(filePath) {
        this.$http
            .get("basic", `files/getDownloadUrl?key=${encodeURIComponent(filePath)}`)
            .then((res) => {
              if (res.success) {
                window.open(res.data);
              }
            })
            .catch(() => {
              this.$confirm("文件路径获取失败", "错误", {
                type: "error",
                showCancelButton: false,
              });
            });
      },

      download() {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(this.esopVo.detailVos[0].filePath)}`).then((res) => {
          if (res.success) {
            window.open(res.data);
          }
        });
      },

      doApprove() {
        let params = {
          billId: parseInt(this.billId),
          billType: parseInt(this.billType),
          sequId: parseInt(this.sequId),
          actionType: this.params.actionType,
          approveNote: this.params.approveNote,
          untreadedFlowId: this.params.untreadedFlowId,
          billParam: "",
        };
        this.$emit("loading-status", {loading: true});
        this.$http
            .post("basic", "applications/doApprove", params)
            .then(() => {
              this.$emit("loading-status", {loading: false});
              this.$message.success("保存成功");
              if (this.esopVo.fileType !== this.tempFileType) {
                this.fileTypeChange(this.esopVo.esopId, this.esopVo.fileType);
              }
              if (this.esopVo.departmentId > 0) {
                this.sendMsg();
              }

              // 关闭标签
              this.$bus.$emit("closeTag", this.$route);
              this.$router.push({
                path: "/workFlow/EsopFileApplication",
              });
            })
            .catch(() => {
              this.$emit("loading-status", {loading: false});
            });
      },

      uploadSuccess(file) {
        const params = {
          pkid: this.esopVo.esopId,
          esopName: file[0].name,
          filePath: file[0].key,
        };
        this.$http.post("basic", "esops/saveEsop", params).then((res) => {
          if (res.success) {
            this.$message.success("上传成功");
            this.getData();
          }
        });
      },

      // 文件类型变更
      fileTypeChange(id, fileType) {
        this.$http.post("basic", `esops/updateFileType/${id}/${fileType}`).then((res) => {
          console.log(res);
        });
      },
      //通知部门
      sendMsg() {
        this.$http.post("basic", "esops/sendMsg", this.esopVo).then((res) => {
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.detailInfo {
  border: 1px solid #ddd;
  margin-top: 15px;

  .title {
    height: 35px;
    line-height: 35px;
    background-color: #f4f7fa;
    padding: 0 10px;
  }
}
</style>
